import { useDisclosure, Button } from "@chakra-ui/react"
import { useAppSelector } from "lib/redux";
import { selectMe } from ".";
import { DeleteAccountAlert } from "./deleteAccountAlert";
import { DeleteIcon } from 'lib/icons/delete';
import { useBreakpointValue } from '@chakra-ui/media-query';

export const DeleteAccount = () => {
  const me = useAppSelector(selectMe);
  const isFullWidth = useBreakpointValue([ true, false ]);
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (me.user.delete_scheduled) {
    return null;
  }

  return (
    <>
      <Button
        size="md"
        variant="destructive"
        isFullWidth={isFullWidth}
        onClick={onOpen}
        leftIcon={<DeleteIcon />}
      >
        Delete Account
      </Button>
      <DeleteAccountAlert isOpen={isOpen} onClose={onClose} />
    </>
  )
}
